import type { PluginContainerData } from 'ricos-schema';

const IMAGE_FALLBACK_WIDTH = 300;

export const useFallbackWidthStyle = ({
  containerData,
  isMobile,
}: {
  containerData: PluginContainerData;
  isMobile: boolean;
}) => {
  const shouldUseFallbackWidth =
    (containerData?.alignment === 'LEFT' || containerData?.alignment === 'RIGHT') &&
    !containerData.width?.custom &&
    containerData.width?.size !== 'SMALL' &&
    containerData.width?.size !== 'ORIGINAL' &&
    !isMobile;

  return shouldUseFallbackWidth ? { width: IMAGE_FALLBACK_WIDTH + 'px' } : {};
};
